// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "selected-2d9Bj";
var _3 = "lang_opened-1OrtV";
var _4 = "dropdown-3HXyP";
var _5 = "icon-3bVJP";
export { _1 as "__esModule", _2 as "selected", _3 as "lang_opened", _4 as "dropdown", _5 as "icon" }
export default { "__esModule": _1, "selected": _2, "lang_opened": _3, "dropdown": _4, "icon": _5 }
